import { CommonApiFuncService, StorageService, StorageType } from '@anddone/ui-utilities';
import { Injectable, inject } from '@angular/core';
import { APIConstants } from '../constants/api.constant';
import { catchError, tap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordUser {
  loggedInUserData: any;
  private commonAPIFuncService = inject(CommonApiFuncService);
  private storageService = inject(StorageService);

  getLoggedInData() {
    return JSON.parse(this.storageService.get(StorageType.Session, 'userDetails') ?? '{}');
  }

  changePassword(data: any, userName: string, _userType: string, _parentID: string) {
    this.loggedInUserData = this.getLoggedInData();
    const url = APIConstants.settingChangePassword.changePassword.replace('{userName}', userName);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.post(url, data, options).pipe(
      tap((_a) => this.commonAPIFuncService.log(`changePassword success`)),
      catchError(this.commonAPIFuncService.handleError('changePassword error/failed'))
    );
  }
}
